import { CpDataApi } from 'cp-xhr';
import React from 'react';
import { EndpointMockDescription, MockOptions, setupMockResponses } from '@cp-shared-15/frontend-storybook-extensions';
import { DefaultBusinessMarketApiError, DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { dealerDetailsWithAllValues } from './ExampleData';
import { ContractsWithAllValues } from '../ExampleData';
import { ContractsMock } from './contractsMock';

const mockOptions: MockOptions<DefaultBusinessMarketApiErrorCode> = {
    Success: {
        status: 200,
        responseBody: dealerDetailsWithAllValues,
        delay: 1000,
    },
    'Business Error': DefaultBusinessMarketApiError,
    'Unexpected/Connection Error': {
        status: 500,
    },
};

export const DealerDetailsMock: EndpointMockDescription<DefaultBusinessMarketApiErrorCode> = {
    name: 'Dealer Details Response',
    method: 'get',
    defaultMockOption: 'Success',
    mockOptions,
    url: ContractsWithAllValues[0]._links?.dealerDetails || '',
};

export const DealerDetailsResponseMockWrapper = (storyFn: () => React.ReactNode) => {
    setupMockResponses(CpDataApi, [ContractsMock, DealerDetailsMock]);

    return <div>{storyFn()}</div>;
};
